import { useState, useEffect, useRef } from "react";
import { Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { isAdminAction } from "@redux/actions/authActions";
import { LoadingToRedirect } from "@components";
import VerticalLayout from "@layouts/VerticalLayout";

const AdminRoute = ({ children, ...restProps }) => {
  const dispatch = useDispatch();
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(true);
  const authCheckStarted = useRef(false);

  // Check if current user is admin
  useEffect(() => {
    // Prevent double execution in StrictMode
    if (authCheckStarted.current) return;
    authCheckStarted.current = true;

    let isMounted = true;

    const checkAuth = async () => {
      try {
        await dispatch(isAdminAction({
          setOk: (value) => {
            if (isMounted) {
              setOk(value);
              setLoading(false);
            }
          }
        }));
      } catch (error) {
        console.error("Auth check failed:", error);
        if (isMounted) {
          setLoading(false);
          setOk(false);
        }
      }
    };

    checkAuth();

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  // If still loading, show loading state
  if (loading) {
    return (
      <div className="preloader-container">
        <div id="copilotly-loader">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      {ok ? (
        <VerticalLayout>
          <Route {...restProps} render={children} />
        </VerticalLayout>
      ) : (
        <LoadingToRedirect />
      )}
    </>
  );
};

export default AdminRoute;
